// A regra "com sessão Swipe e sem Bearer, o pedido autenticado não sai" (AP-116, sonda
// AUTH do cybersec, 29/09/2026), num lugar só: o `request()` do api.ts e o snapshot do
// catálogo, que faz o fetch dele por fora do `request()`.
//
// Com sessão Swipe, um Bearer `null` quer dizer que o token da conta não veio: o refresh
// passou do prazo de quem chamou (o voo segue, ver sync/swipe-session.ts), a rede caiu, ou
// o servidor respondeu erro com o access já vencido. A sessão segue viva. Mandar o pedido
// sem autenticação era 401 garantido, e o 401 do api.ts desloga a UI com a sessão no
// disco. Pra quem chamou é falha transitória. Se a sessão MORREU (o refresh tomou 401),
// ela não existe mais aqui e a regra não se aplica: segue o de sempre (401, sessão
// expirada, o usuário entra de novo).
//
// Só pra pedido AUTENTICADO: rota pública (branding, login) não leva Bearer e sai sempre.

import { hasSwipeSession } from './sync/swipe-session'

/** O pedido autenticado ficaria sem o Bearer da conta Swipe logada? Então ele não sai. */
export function authenticatedRequestLacksSwipeBearer(auth: boolean, bearer: string | null): boolean {
  return auth && bearer === null && hasSwipeSession()
}
